import { Column, ModelBase } from 'loca-boot-core'

export class OpsNoteCreateRequest extends ModelBase {
  // string
  @Column()
  public url!: string;
}
